import React, { Component } from 'react';

import { trans } from '../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import {
  EnumMerchantPaidMethod,
  EnumPagingMode, EnumReportRestaurantSortField,
  findEnumById,
} from '../../../../constants/enum';
import {
  convertPriceToValue,
  formatCurrency,
  isEmpty,
  isEmptyObject,
} from '../../../../utils/utils';
import { sortReportRestaurant } from './utils';
import { getSortData } from '../../../../utils/sort';

import TableEmpty from '../../../../components/Common/TableEmpty'


function PageTableCellNumberOrder({
  orderSumTotal,
  stats,
  openTransactionRestaurantReport,
  restaurant,
}) {
  return (
    <PageTableCell className="col-number-order">
      <div className="font-weight-bold">{orderSumTotal}</div>
      {stats.map(item => (
        <div className="icon-payment flex" key={item.type}>
          <span
            className={`icon ${
              findEnumById(EnumMerchantPaidMethod, item.type).icon
            }`}
          />
          <button
            className="more-detail"
            onClick={() =>
              openTransactionRestaurantReport(restaurant, item.type)
            }
          >
            <i className="fas fa-chevron-right" />
          </button>
          {item.order_sum}
        </div>
      ))}
    </PageTableCell>
  );
}

function PageTableCellTotalCommissionOrder({ valueSumTotal, stats }) {
  return (
    <PageTableCell className="col-number-order" textAlign="right">
      <div className="font-weight-bold">{valueSumTotal}</div>
      {stats.map(item => (
        <div className="icon-payment" key={item.type}>
          {item.include_commission_value_sum}
        </div>
      ))}
    </PageTableCell>
  );
}

function PageTableCellTotalOrder({ valueSumTotal, stats }) {
  return (
    <PageTableCell className="col-number-order" textAlign="right">
      <div className="font-weight-bold">{valueSumTotal}</div>
      {stats.map(item => (
        <div className="icon-payment" key={item.type}>
          {item.value_sum}
        </div>
      ))}
    </PageTableCell>
  );
}

class ReportRestaurantTable extends Component {
  state = {
    sort: null,
    sortOrder: null,
  };

  renderHeader = () => {
    const { sort, sortOrder } = this.state;

    const columns = [
      {
        id: 'number',
        label: trans('mod_report_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'restaurant',
        label: trans('mod_report_header_restaurant'),
        width: '40%',
        sort: EnumReportRestaurantSortField.RESTAURANT.id,
      },
      {
        id: 'quantity_order',
        label: trans('mod_report_header_quantity_order'),
        width: '15%',
        textAlign: 'left',
        sort: EnumReportRestaurantSortField.QUANTITY_ORDER.id,
      },
      {
        id: 'total_amount_before_discount',
        label: trans('mod_report_header_total_amount_before_discount'),
        width: '10%',
        textAlign: 'right',
        sort: EnumReportRestaurantSortField.TOTAL_AMOUNT_BEFORE_DISCOUNT.id
      },
      {
        id: 'merchant_discount',
        label: trans('mod_report_header_merchant_discount'),
        width: '10%',
        textAlign: 'right',
        sort: EnumReportRestaurantSortField.MERCHANT_DISCOUNT.id,
      },
      {
        id: 'commission',
        label: trans('mod_report_header_commission'),
        width: '10%',
        textAlign: 'right',
        sort: EnumReportRestaurantSortField.COMMISSION.id,
      },
      {
        id: 'total_amount',
        label: trans('mod_report_header_total_amount'),
        width: '10%',
        textAlign: 'right',
        sort: EnumReportRestaurantSortField.TOTAL_AMOUNT.id,
      },
    ];

    return (
      <PageTableHeader
        columns={columns}
        onClick={this.onSort}
        sort={sort}
        sortOrder={sortOrder}
      />
    );
  };

  onSort = (newSort) => {
    const { sort: oldSort, sortOrder } = this.state;
    this.setState(getSortData(oldSort, newSort, sortOrder));
  };

  renderRow = (row, index) => {
    const { openTransactionRestaurantReport } = this.props;
    const { id, name, success_order: successOrder } = row;
    const {
      order_sum_total: orderSumTotal,
      value_sum_total: valueSumTotal,
      include_commission_value_sum_total: commissionValueSumTotal,
      stats,
      merchant_discount_amount: merchantDiscountAmount,
      commission_fee: commissionFee,
    } = successOrder;
    return (
      <PageTableRow key={id}>
        <PageTableCell textAlign="center" className="col-stt">
          {index}
        </PageTableCell>
        <PageTableCell className="col-restaurant">{name}</PageTableCell>
        <PageTableCellNumberOrder
          stats={stats}
          restaurant={{ restaurantId: id, name }}
          orderSumTotal={orderSumTotal}
          openTransactionRestaurantReport={openTransactionRestaurantReport}
        />
        <PageTableCellTotalCommissionOrder
          stats={stats}
          valueSumTotal={commissionValueSumTotal}
        />
        <PageTableCell className="font-weight-bold" textAlign="right">
          {merchantDiscountAmount.text}
        </PageTableCell>
        <PageTableCell className="font-weight-bold" textAlign="right">
          {commissionFee.text}
        </PageTableCell>
        <PageTableCellTotalOrder stats={stats} valueSumTotal={valueSumTotal} />
      </PageTableRow>
    );
  };

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty txt="mod_report_table_not_find" />
        </PageTableCell>
      </PageTableRow>
    );
  }

  renderExtraRowInfo = () => {
    const { table, filters } = this.props;
    const { isShowTotal } = filters;
    const { itemData, itemList } = table;
    if (!isShowTotal || isEmptyObject(itemData)) {
      return null;
    }

    const listDatas = itemList.map(id => itemData[id]);

    const listDataCaculator = listDatas.map((order) => {
      let totalOrderRestaurant = 0;
      let totalOrderWalletRestaurant = 0;
      let totalOrderCODRestaurant = 0;
      let totalCommissionRestaurant = 0;
      let totalCommissionWalletRestaurant = 0;
      let totalCommissionCODRestaurant = 0;
      let totalAmountRestaurant = 0;
      let totalAmountWalletRestaurant = 0;
      let totalAmountCODRestaurant = 0;
      let totalMerchantDiscountRestaurant = 0;
      let totalCommissionFeeRestaurant = 0;
      if (!isEmpty(order) && !isEmptyObject(order.success_order)) {
        const { success_order: successOrder } = order;
        const { unit } = successOrder.value_sum_total_detail;
        totalOrderRestaurant = successOrder.order_sum_total;
        totalAmountRestaurant = successOrder.value_sum_total_detail.value;
        totalCommissionRestaurant =
          successOrder.include_commission_value_sum_total_detail.value;
        totalMerchantDiscountRestaurant =
          successOrder.merchant_discount_amount.value;
        totalCommissionFeeRestaurant = successOrder.commission_fee.value;
        if (!isEmptyObject(successOrder.stats)) {
          const priceCOD = successOrder.stats.find(
            stat => stat.type === EnumMerchantPaidMethod.COD.id,
          );
          const priceWallet = successOrder.stats.find(
            stat => stat.type === EnumMerchantPaidMethod.TOPPAY.id,
          );
          if (priceCOD) {
            totalAmountCODRestaurant = convertPriceToValue(
              priceCOD.value_sum,
              unit,
            );
            totalOrderCODRestaurant = priceCOD.order_sum;
            totalCommissionCODRestaurant = convertPriceToValue(
              priceCOD.include_commission_value_sum,
              unit,
            );
          }
          if (priceWallet) {
            totalAmountWalletRestaurant = convertPriceToValue(
              priceWallet.value_sum,
              unit,
            );
            totalOrderWalletRestaurant = priceWallet.order_sum;
            totalCommissionWalletRestaurant = convertPriceToValue(
              priceWallet.include_commission_value_sum,
              unit,
            );
          }
        }
      }
      return {
        totalOrderRestaurant,
        totalOrderWalletRestaurant,
        totalOrderCODRestaurant,
        totalCommissionRestaurant,
        totalCommissionWalletRestaurant,
        totalCommissionCODRestaurant,
        totalAmountRestaurant,
        totalAmountWalletRestaurant,
        totalAmountCODRestaurant,
        totalMerchantDiscountRestaurant,
        totalCommissionFeeRestaurant,
      };
    });

    const totalOrder = listDataCaculator.reduce(
      (total, item) => total + item.totalOrderRestaurant,
      0,
    );
    const totalOrderWallet = listDataCaculator.reduce(
      (total, item) => total + item.totalOrderWalletRestaurant,
      0,
    );
    const totalOrderCOD = listDataCaculator.reduce(
      (total, item) => total + item.totalOrderCODRestaurant,
      0,
    );
    const totalCommission = listDataCaculator.reduce(
      (total, item) => total + item.totalCommissionRestaurant,
      0,
    );
    const totalCommissionWallet = listDataCaculator.reduce(
      (total, item) => total + item.totalCommissionWalletRestaurant,
      0,
    );
    const totalCommissionCOD = listDataCaculator.reduce(
      (total, item) => total + item.totalCommissionCODRestaurant,
      0,
    );
    const totalAmount = listDataCaculator.reduce(
      (total, item) => total + item.totalAmountRestaurant,
      0,
    );
    const totalAmountWallet = listDataCaculator.reduce(
      (total, item) => total + item.totalAmountWalletRestaurant,
      0,
    );
    const totalAmountCOD = listDataCaculator.reduce(
      (total, item) => total + item.totalAmountCODRestaurant,
      0,
    );
    const totalMerchantDiscount = listDataCaculator.reduce(
      (total, item) => total + item.totalMerchantDiscountRestaurant,
      0,
    );
    const totalCommissionFee = listDataCaculator.reduce(
      (total, item) => total + item.totalCommissionFeeRestaurant,
      0,
    );
    return (
      <PageTableRow>
        <PageTableCell
          textAlign="right"
          className="font-weight-bold"
          colSpan="2"
        >
          {trans('total')}
        </PageTableCell>
        <PageTableCell className="text-left font-weight-bold">
          <div className="font-weight-bold">
            {formatCurrency(totalOrder, '')}
          </div>
          <div className="icon-payment">
            <span className={`icon ${EnumMerchantPaidMethod.COD.icon}`} />
            {totalOrderCOD}
          </div>
          <div className="icon-payment">
            <span className={`icon ${EnumMerchantPaidMethod.TOPPAY.icon}`} />
            {totalOrderWallet}
          </div>
        </PageTableCell>
        <PageTableCell className="text-right font-weight-bold">
          <div className="font-weight-bold">
            {formatCurrency(totalCommission)}
          </div>
          <div className="icon-payment">
            {formatCurrency(totalCommissionCOD)}
          </div>
          <div className="icon-payment">
            {formatCurrency(totalCommissionWallet)}
          </div>
        </PageTableCell>
        <PageTableCell className="text-right font-weight-bold">
          {formatCurrency(totalMerchantDiscount)}
        </PageTableCell>
        <PageTableCell className="text-right font-weight-bold">
          {formatCurrency(totalCommissionFee)}
        </PageTableCell>
        <PageTableCell className="text-right font-weight-bold">
          <div className="font-weight-bold">{formatCurrency(totalAmount)}</div>
          <div className="icon-payment">{formatCurrency(totalAmountCOD)}</div>
          <div className="icon-payment">
            {formatCurrency(totalAmountWallet)}
          </div>
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { sort, sortOrder } = this.state;
    const { table, getList, changePageSize, changeActivePage } = this.props;

    sortReportRestaurant(table, sort, sortOrder);

    return (
      <PageTable
        className="order-table"
        paginationMode={EnumPagingMode.PAGING_IDS.id}
        table={table}
        renderHeader={this.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={ReportRestaurantTable.renderEmpty}
        renderExtraRowInfo={this.renderExtraRowInfo}
        getList={getList}
        changePageSize={changePageSize}
        changeActivePage={changeActivePage}
      />
    );
  }
}

export default ReportRestaurantTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/components/ReportRestaurantTable.jsx